import type BaseAbility from 'uplisting-frontend/abilities/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import BookingAbility from 'uplisting-frontend/abilities/booking';

interface IAbilityFactory {
  create(props: { model: unknown }): BaseAbility<keyof ModelRegistry>;
}

export const ABILITIES: Record<string, IAbilityFactory> = {
  booking: BookingAbility,
};
